import Prism from 'prismjs';
import { detectLanguage } from './DetectLanguageUtils';

// Import all the Prism language components here
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-jsx';
import 'prismjs/components/prism-tsx';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-gherkin';

// Utility function to map file extensions to Prism language identifiers
const getLanguageFromExtension = (extension, fallbackLanguage) => {
  const languageMap = {
    'py': 'python',
    'js': 'javascript',
    'jsx': 'jsx',
    'ts': 'typescript',
    'tsx': 'tsx',
    'java': 'java',
    'css': 'css',
    'sql': 'sql',
    'feature': 'gherkin',
    'txt': 'plaintext'
  };
  
  return languageMap[extension] || fallbackLanguage || 'plaintext';
};

// Determine the language for a code snippet
export const determineLanguage = (code, specifiedLanguage) => {
  if (!code) return 'plaintext';
  
  try {
    const detectedExtension = detectLanguage(code);
    return getLanguageFromExtension(detectedExtension, specifiedLanguage);
  } catch (error) {
    return specifiedLanguage || 'plaintext';
  }
};

// Function to load the appropriate Prism theme based on dark mode
export const loadPrismTheme = (isDarkMode) => {
  // Remove any existing Prism theme stylesheets
  const existingLinks = document.querySelectorAll('link[data-prism-theme]');
  existingLinks.forEach(link => link.remove());
  
  // Create and append the new theme stylesheet
  const link = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('data-prism-theme', 'true');
  
  if (isDarkMode) {
    link.setAttribute('href', 'https://cdnjs.cloudflare.com/ajax/libs/prism/1.24.1/themes/prism-dark.min.css');
  } else {
    link.setAttribute('href', 'https://cdnjs.cloudflare.com/ajax/libs/prism/1.24.1/themes/prism-coy.min.css');
  }
  
  document.head.appendChild(link);
};

// Highlight code using Prism
export const highlightCode = (code, language) => {
  if (!code) return '';
  
  const effectiveLanguage = determineLanguage(code, language);
  
  try {
    return Prism.highlight(
      code, 
      Prism.languages[effectiveLanguage] || Prism.languages.plaintext, 
      effectiveLanguage
    );
  } catch (error) {
    return code;
  }
};

// Create named object for default export
const SyntaxColouring = {
  determineLanguage,
  highlightCode
};

export default SyntaxColouring;